// extracted by mini-css-extract-plugin
export default {"link":"xB-z","disabled":"yB-z"};